module.exports = __webpack_public_path__ + "static/media/SDFSA_7-845w.e7071a31.webp";